import React from 'react';

export default function AccountDeletionPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <main className="max-w-3xl mx-auto px-4 py-10" data-testid="account-deletion-page">
        <h1 className="text-2xl font-semibold">Konto in der App Musik Akademie löschen</h1>
        <p className="mt-2 text-slate-600">
          Anbieter ist Magic Concerts UG (haftungsbeschränkt). Diese Seite ist ohne Anmeldung lesbar.
        </p>

        <h2 className="mt-8 text-lg font-semibold">So löschst du das Konto</h2>
        <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm leading-relaxed">
          <li>Öffne die App Musik Akademie oder <a className="underline" href="https://mamv.info/m">mamv.info/m</a> und melde dich mit E-Mail und Passwort an.</li>
          <li>Tippe unten auf Menü.</li>
          <li>Tippe auf Konto löschen.</li>
          <li>Gib dein Passwort ein.</li>
          <li>Tippe auf Konto endgültig löschen.</li>
        </ol>
        <p className="mt-4 text-sm leading-relaxed">
          Die Löschung erfolgt sofort. Für die App-Daten gibt es keine weitere Aufbewahrungsfrist.
        </p>

        <h2 className="mt-8 text-lg font-semibold">Was gelöscht wird</h2>
        <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-relaxed">
          <li>Name, E-Mail und Passwort des App-Kontos</li>
          <li>Push-Benachrichtigungen und Gerätekennungen der App</li>
          <li>Einstellungen der App</li>
          <li>Die Verknüpfung mit der Schulkennung. Die Kennung wird frei und kann neu vergeben werden.</li>
        </ul>

        <h2 className="mt-8 text-lg font-semibold">Was bleibt</h2>
        <p className="mt-3 text-sm leading-relaxed">
          Schulakten bleiben: Unterricht, Anwesenheit, Rechnungen und die Stammdaten bei der Musikschule.
          Bereits gesendete Nachrichten bleiben für die anderen Personen der Schule sichtbar, der Absender
          heißt danach „Gelöschtes Konto“. Einzelne App-Daten lassen sich nicht getrennt löschen.
          Für die Schulakte wendest du dich an die Verwaltung deiner Schule.
        </p>

        <h2 className="mt-10 text-lg font-semibold">Delete your Musik Akademie app account</h2>
        <p className="mt-3 text-sm leading-relaxed">
          Developer: Magic Concerts UG (haftungsbeschränkt). Open the Musik Akademie app or mamv.info/m,
          sign in, tap Menu, tap Konto löschen, enter your password, then tap Konto endgültig löschen.
          Deletion is immediate. The app account’s name, email, password, push data and settings are removed,
          and the school identity link is released. School records stay, including lessons (Unterricht),
          attendance and invoices. Sent messages stay visible to the school, shown as a deleted account.
          You cannot delete only part of the app data.
        </p>
      </main>
    </div>
  );
}
